import View from '@core/View';
import User from '../User';
import ItemSummaryDialog from './ItemSummaryDialog';
import {Cart} from './Cart';
import CartQuickAddItem from './CartQuickAddItem';
import pathOr from 'ramda/src/pathOr';
import {toCurrency} from '@util/NumberUtil';
import {jqueryEasing, jqueryToggleQtySelect} from '@modules/lazy-imports';
import isSiteFeatureEnabled from '@util/fn/isSiteFeatureEnabled';
import {toProductUrl} from '@util/URLUtils';

const {STORE_URL, LOGIN_URL} = upi.paths;
const {FREE_SHIPPING_GOAL} = upi.conf;

const CartQuickView = ItemSummaryDialog.extend( {

    dataLayer: upi.dataLayer.cart,

    init: async function () {
        await jqueryEasing();

        const summaryType = isSiteFeatureEnabled( 'FreeShippingMsg' ) ?
            'cartSummaryShippingMsg' :
            'cartQuickViewSummary';

        this.cartSummaryView = new View( summaryType );
        this.cartQuickViewItemDetailView = new View( 'cartQuickViewItemDetail' );
        this.cartQuickViewAddConfirmationView = new View( 'cartQuickViewAddConfirmation' );

        this.loadModules().then( modal => {
            this.quickAdd = new CartQuickAddItem( modal.selector );
        } );

        Cart.bind( 'quickadd:item', ( e, data ) => {
            this.renderSummary( data );
        } );
    },

    renderSummary: function ( cart ) {
        var dataLayer = this.dataLayer,
            lineItems = this.serializeLineItems( cart.itemAdditions ),
            cartSummaryData = this.serializeCartSummary( cart ),
            dialogTmpl = $( this.itemSummaryLayoutView.render( {
                quantityTotal: this.getQuantitiesFor( lineItems ),
                skus: lineItems
            } ) );

        var addConfirmationTmpl = $( this.cartQuickViewAddConfirmationView.render( {
                skus: lineItems.map( line => ({
                    ...line,
                    imgSrc: this.getItemImageSource( line )
                }) ),
                cart: cartSummaryData
            } ) ),
            summaryTmpl = this.cartSummaryView.render( cartSummaryData );

        // append item details to qv-layout
        dialogTmpl.find( '#qv-order-summary' ).html( summaryTmpl );
        dialogTmpl.find( '#qv-content' ).html( addConfirmationTmpl );

        // only display recs if a single item was added
        if ( 1 === lineItems.length ) {
            this.recommendations
                .fetch( lineItems[0].product.sku )
                .then( ( recommendations ) => {
                    const
                        recs = recommendations.skuRecommendations,
                        recsHtml = recommendations.renderAccessories();

                    addConfirmationTmpl.find( '#qv-item-recs' ).append( recsHtml );
                    dataLayer.sendCrossSellItems( recs.slice( 0, 3 ) );
                } );
        }

        this.modal.open( {
            position: this.modalOptions.position,
            width: this.modalOptions.width,
            content: dialogTmpl
        } );

        this.continueButton.focus();

        if ( isSiteFeatureEnabled( 'FreeShippingMsg' ) ) {
            setTimeout( this.animateMeter.bind( this, dialogTmpl, cart ), 0 );
        }
    },

    serializeCartSummary: function ( cart ) {
        const adjustedCartSummary = $.extend( {}, cart, {
            isLogged: User.isLogged(),
            cartLink: STORE_URL,
            signinLink: LOGIN_URL,
            itemCount: pathOr( 0, ['lineItems', 'length'], cart ),
            subtotal: toCurrency( parseFloat( cart.subtotal ) ),
            shippingGoal: toCurrency( parseFloat( FREE_SHIPPING_GOAL ), true ),
            goalReached: cart.subtotal > FREE_SHIPPING_GOAL,
            amountRemainingForShippingGoal: cart.subtotal
                ? toCurrency( this.getAmountRemainingForShippingGoal( cart.subtotal ) )
                : null
        } );

        return adjustedCartSummary;
    },

    animateMeter: function ( el, data ) {
        var cartTotalEl = el.find( '#qv-order-total-value' ),
            msgEl = el.find( '.qv-order-shipping-msg' ),
            goalEl = el.find( '#qv-shipping-goal-value' ),
            orderSubTotal = data.subtotal,
            goalReached = data.subtotal > FREE_SHIPPING_GOAL,
            percentOfShippingGoal = this.getPercentOfShippingGoal( orderSubTotal );

        if ( !orderSubTotal ) {
            return;
        }

        // initialize transition for free shipping meter
        el.find( '.progress-meter-value' )
            .width( 0 )
            .delay( 1500 )
            .animate(
                {width: percentOfShippingGoal + '%'},
                {
                    easing: 'easeOutCubic',
                    duration: 1500,
                    step: function ( now ) {
                        var dollarAmount = parseFloat( orderSubTotal * (now / percentOfShippingGoal) );
                        cartTotalEl.text( !isNaN( dollarAmount ) ? toCurrency( dollarAmount ) : 0 );
                    },
                    complete: function () {
                        msgEl.removeClass( 'is-hidden' );
                        if ( goalReached ) {
                            goalEl.addClass( 'success' );
                        }
                    }
                }
            );
    },

    getPercentOfShippingGoal: function ( orderSubTotal ) {
        if ( !orderSubTotal ) {
            return 0;
        }

        return Math.max( Math.min( orderSubTotal / FREE_SHIPPING_GOAL, 1 ), 0 ) * 100;
    },

    getAmountRemainingForShippingGoal: function ( orderSubTotal ) {
        var goal = FREE_SHIPPING_GOAL;

        if ( !orderSubTotal ) {
            return 0;
        }
        return Math.max( Math.min( goal - orderSubTotal, goal ), 0 );
    },

    getCustomerPrice( {customerPrice, catalogPrice} ) {
        return toCurrency( parseFloat( customerPrice || catalogPrice, 10 ) );
    },

    renderDetails: function ( product ) {
        console.log( product );
        const lineItems = this.serializeLineItems( [{product}] ),
            firstItem = lineItems[0],
            dialogTmpl = $( this.itemSummaryLayoutView.render( {skus: lineItems} ) ),
            itemDetailTmpl = $( this.cartQuickViewItemDetailView.render( {
                skus: lineItems,
                item: {
                    ...firstItem,
                    ...firstItem.product,
                    displayPrice: `$${this.getCustomerPrice( firstItem.product )}`
                }

            } ) );

        // append item details to qv-layout
        jqueryToggleQtySelect().then( () =>
            itemDetailTmpl.find( '#skuQty' ).toggleQtySelect()
        );

        dialogTmpl.find( '#qv-content' ).html( itemDetailTmpl );

        this.modal.open( {
            position: this.modalOptions.position,
            width: this.modalOptions.width,
            content: dialogTmpl
        } );

        this.quickAdd.refresh();
    }
} );

export default CartQuickView;
